import { Box } from '@creditas-ui/react';
import { Card, CardHeader, CardContent, CardBackground } from '@/components/Card';
import { useWindowResize } from '@/hooks/helpers/useWindowResize';
import QrCodeImg from '@/assets/images/qr_code.webp';
import i18n from '@/i18n';
import { Tag, Title, Description, QrCode } from './DownloadAppSection.style';
import { redirect } from '@/utils/redirect';

const DownloadAppSection = (): JSX.Element | null => {
  const { isMobile } = useWindowResize();

  const handleClick = () => {
    if (isMobile) {
      redirect(i18n.t('downloadAppSection:card.href'));
    }
  };

  return (
    <Card
      onClick={handleClick}
      bg="neutral.90"
      marginTop="24px"
      marginBottom={{ _: '81px', '5xl': '64px' }}
    >
      <Box>
        <CardHeader padding="32px 24px 0">
          <Tag color="neutral.0" variant="bodyXsBold">
            {i18n.t('downloadAppSection:card.tag').toUpperCase()}
          </Tag>
        </CardHeader>
        <CardContent marginTop="16px" padding="0 24px 32px">
          <Title color="neutral.0" variant="bodyXlRegular">
            {i18n.t('downloadAppSection:card.title')}
          </Title>

          {isMobile ? (
            <Description color="neutral.0" variant="bodySmRegular">
              {i18n.t('downloadAppSection:card.descriptionMobile')}
            </Description>
          ) : (
            <Description color="neutral.0" variant="bodySmRegular">
              {i18n.t('downloadAppSection:card.description')}
            </Description>
          )}
        </CardContent>
      </Box>
      {isMobile ? null : (
        <CardBackground right="24px" top="32px">
          <QrCode data-testid="qr-code">
            <img src={QrCodeImg} alt="QR Code" />
          </QrCode>
        </CardBackground>
      )}
    </Card>
  );
};

export { DownloadAppSection };
